import { lazy } from 'react';

export { Tender } from './tender';

export const LazyTender = lazy(() => import('./tender').then((mod) => ({ default: mod.Tender })));
